'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reduxActions = require('redux-actions');

var _initialMessageBubbleActionTypes = require('../constants/initialMessageBubbleActionTypes');

var initialState = false;

exports.default = (0, _reduxActions.handleAction)(_initialMessageBubbleActionTypes.TOGGLE_INITIAL_MESSAGE_BUBBLE, function (state, action) {
  var visible = action.payload.visible;


  return visible;
}, initialState);
module.exports = exports['default'];